import { render } from "./PageMarker.vue?vue&type=template&id=53954fda"
import script from "./PageMarker.vue?vue&type=script&lang=js"
export * from "./PageMarker.vue?vue&type=script&lang=js"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__